import API from "..";
import { checkAPIResponse } from "../helpers";

export default class WorkRequestFacility {

  constructor({
    facilityName,
    isActive,
    siteName,
    workRequestTypes,
    primaryContact
  }) 
    
  {
    this.facilityName = facilityName;
    this.isActive = isActive;
    this.siteName = siteName;
    this.workRequestTypes = workRequestTypes;
    this.primaryContact = primaryContact;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/workRequestFacility`);
    if (data.result) {
        return data.result.map((d) => new WorkRequestFacility(d));
    }
    else {
        return [];
    }
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/workRequestFacility`);
    if (data && data.result && data.result.length > 0) {
        return data.result.filter((d) => d.isActive);
    }
    else {
        return [];
    }
  }

  static async get(name) {
    const api = await API();
    const { data } = await api.get(`workRequestFacility/${name}`);
    return data.result ?  new WorkRequestFacility(data.result) : null;
  }

  static async add(info) {
    const api = await API();
    const response = await api.post(`/workRequestFacility`, info);
    checkAPIResponse(response);
    return new WorkRequestFacility(response.data.result);
  }

  static async update(info) {
    const api = await API();
    const response = await api.put(`/workRequestFacility`, info);
    checkAPIResponse(response);
    return new WorkRequestFacility(response.data.result);
  }
}
